import Splitting from "splitting";
import gsap from "gsap";
import SplitType from 'split-type';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class DataEffect21 {
    constructor() {
        Splitting();

        // Modifica il selettore qui in base alle tue esigenze
        this.selector = '.content__title[data-splitting][data-effect21]';
        this.text = new SplitType(this.selector);

        // Retrieve elements with data effect 21
        this.fx21Titles = [...document.querySelectorAll(this.selector)];
    }

    applyEffect() {
        this.fx21Titles.forEach(title => {
            const words = [...title.querySelectorAll('.word')];

            for (const word of words) {
                const chars = word.querySelectorAll('.char');

                chars.forEach(char => gsap.set(char.parentNode, { perspective: 2000 }));

                gsap.fromTo(chars, {
                        'will-change': 'opacity, transform',
                        opacity: 0,
                        y: (position, _, arr) => -40 * Math.abs(position - arr.length / 2),
                        z: () => gsap.utils.random(-1500, -600),
                        rotationX: () => gsap.utils.random(-500, -200)
                    },
                    {
                        ease: 'power1.inOut',
                        opacity: 1,
                        y: 0,
                        z: 0,
                        rotationX: 0,
                        stagger: {
                            each: 0.06,
                            from: 'center'
                        },
                        scrollTrigger: {
                            trigger: word,
                            start: 'top center', // Modificato da 'top bottom'
                            end: 'top top+=32%',
                            scrub: true,
                        }
                    });
            }
        });
    }
}

export default DataEffect21;